const baseURL = "/v1/Turma";

const service = {
  methods: {
    $buscarTurmas(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarTurmas({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarTurma(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarTurma(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarTurma(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    }
  },
};

export default service;
